<template>
    <div @mouseover="onHover()" @mouseleave="onLeave()" class="select-box" v-if="options[currentIndex] !== undefined">
        <div class="select-box-header" :class="(isMenu)? 'for-menu font-bold':'for-country'" v-on:click.stop="toggleMenu()">
            <span :class="Object.prototype.hasOwnProperty.call(options[currentIndex], 'textClass')? options[currentIndex].textClass : ''">
                {{translate(translationType, options[currentIndex].name, language)}}
            </span>&nbsp;
            <span
                    class="badge"
                    :class="Object.prototype.hasOwnProperty.call(options[currentIndex], 'badgeType')? options[currentIndex].badgeType : 'badge-primary'"
                    v-if="Object.prototype.hasOwnProperty.call(options[currentIndex], 'value')"
            >
                {{options[currentIndex].value}}
            </span>
            <font-awesome-icon icon="fa-solid fa-angle-up" v-if="menuIsShown"/>
            <font-awesome-icon icon="fa-solid fa-angle-down" v-else/>
        </div>
        <div v-if="menuIsShown" class="select-box-body" :class="(isMenu)? 'for-menu':'for-country'">
            <div class="select-box-options">
                <div v-for="(option, index) in options"
                     class="select-box-option flex"
                     :class="(currentIndex === index)? 'active': ''"
                     :key="'select_box_' + index"
                     v-on:click.stop="valueSelected(index)"
                >
                    <div class="select-box-option-activated"></div>
                    <div class="select-box-option-value">
                        <span :class="Object.prototype.hasOwnProperty.call(option, 'textClass')? option.textClass : ''">
                            {{translate(translationType, option.name, language)}}
                        </span>&nbsp;
                        <span
                                class="badge"
                                :class="Object.prototype.hasOwnProperty.call(option, 'badgeType')? option.badgeType : 'badge-primary'"
                                v-if="Object.prototype.hasOwnProperty.call(option, 'value')"
                        >
                            {{option.value}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: "SelectBox",
    computed: {
        ...mapGetters({
            isMobile: 'settings/isMobile',
            language: 'settings/language',
        })
    },
    props: {
        options : Object,
        translationType: String,
        currentIndex : String,
        isMenu : Boolean
    },
    data() {
        return {
            menuIsShown : false
        }
    },
    methods : {
        valueSelected(index) {
            this.$emit('selectChange', index)
            this.setIsShownTo(false)
        },
        onHover() {
            if (!this.isMobile){
                this.setIsShownTo(true)
            }
        },
        onLeave() {
            this.setIsShownTo(false)
        },
        toggleMenu() {
            if (this.isMobile){
                this.setIsShownTo(!this.menuIsShown)
            }
        },
        setIsShownTo(value) {
            this.menuIsShown = value
        }
    }
}
</script>

<style scoped>

</style>